import QuestionnaireLayout from './index'
import Questionnaire from './questionnaire'
import QuestionnaireFinished from './questionnaireFinished'
import MicroSite from './microSite'

const indexPageName = 'questionnaireIndexLayout'
const basePath = '/recruiting/questionnaire/:invitationId'

const questionnaireRoute = {
  name: 'questionnaireCommonQuestionnaire',
  path: `${basePath}/questionnaire/:questionnaireId`,
  component: Questionnaire,
  meta: {
    noQuestionnairePermissionCheck: true
  }
}

const questionnaireFinishRoute = {
  name: 'questionnaireCommonQuestionnaireFinished',
  path: `${basePath}/questionnaire-finished`,
  component: QuestionnaireFinished,
  meta: {
    noQuestionnairePermissionCheck: true
  }
}

const questionnaireSiteRoute = {
  name: 'questionnaireSiteLayout',
  path: `${basePath}/site/:siteId/:pagePath*`,
  component: MicroSite,
  meta: {
    title: '',
    noQuestionnairePermissionCheck: true
  }
}

export default {
  name: indexPageName,
  path: `${basePath}/index`,
  component: QuestionnaireLayout,
  meta: {
    title: '',
    noAuth: true,
    noQuestionnairePermissionCheck: true
  },
  children: [
    questionnaireRoute,
    questionnaireFinishRoute,
    questionnaireSiteRoute
  ]
}

export const needIndexRedirectRouteName = [indexPageName]
